export const $ = (sel) => document.querySelector(sel);

export const els = {
  userName: () => $('#user-name'),
  userDropdown: () => $('#user-dropdown'),
  logoutBtn: () => $('#logout-btn'),
  listingSection: () => $('#video-listing-section'),
  listingToggle: () => $('#video-listing-toggle'),
  boundListing: () => $('#video-bound-listing'),
  listingSearch: () => $('#video-listing-search'),
  listingQuery: () => $('#video-listing-query'),
  listingResults: () => $('#video-listing-results'),
  referenceInput: () => $('#video-reference-input'),
  referenceLabel: () => $('#video-reference-label'),
  referenceThumbs: () => $('#video-reference-thumbs'),
  referenceSourceHint: () => $('#video-reference-source-hint'),
  listingImagePicker: () => $('#video-listing-image-picker'),
  prompt: () => $('#video-prompt'),
  promptSource: () => $('#video-prompt-source'),
  videoType: () => $('#video-type'),
  videoTime: () => $('#video-time'),
  modeGroup: () => $('#video-mode-group'),
  modeButtons: () => [...document.querySelectorAll('[data-video-mode]')],
  modeHint: () => $('#video-mode-hint'),
  ratio: () => $('#video-ratio'),
  resolution: () => $('#video-resolution'),
  optimizer: () => $('#video-prompt-optimizer'),
  voice: () => $('#video-voice'),
  camera: () => $('#video-camera'),
  lastFrameField: () => $('#video-last-frame-field'),
  lastFrameInput: () => $('#video-last-frame-input'),
  lastFrameLabel: () => $('#video-last-frame-label'),
  costEstimate: () => $('#video-cost-estimate'),
  generateBtn: () => $('#video-generate-btn'),
  status: () => $('#video-status'),
  preview: () => $('#video-preview'),
  history: () => $('#video-history'),
};

export function setStatus(message, tone = '') {
  const el = els.status();
  if (!el) return;
  el.textContent = message || '';
  if (tone) el.dataset.tone = tone;
  else delete el.dataset.tone;
}
